<template lang="pug">
  DefaultLayout
    CommonSection.b-admin-suppliers-page(title="Поставщики" data-testid="admin-suppliers-page")
      template(#button)
        Btn(blue data-testid="admin-suppliers-create" @click="create") + Поставщик
      ._empty(v-if="!loading && !suppliers.length") Поставщиков пока нет
      table._table(v-if="suppliers.length")
        thead
          tr
            th Название
            th Регион
            th Категории
            th E-mail учётной записи
            th Запросов
            th
        tbody
          tr._row(v-for="supplier in suppliers" :key="supplier.id" data-testid="admin-suppliers-row")
            td
              span._name(data-testid="admin-suppliers-row-name") {{ supplier.name }}
            td
              span(data-testid="admin-suppliers-row-region") {{ supplier.region || '—' }}
            td
              span(data-testid="admin-suppliers-row-categories") {{ categoriesText(supplier) }}
            td
              span(data-testid="admin-suppliers-row-email") {{ supplier.userEmail || '—' }}
            td
              span(data-testid="admin-suppliers-row-requests-count") {{ supplier.requestsCount || 0 }}
            td
              Btn(grey xs data-testid="admin-suppliers-row-edit" @click="edit(supplier)") Изменить
</template>

<script>
import DefaultLayout from '@/layouts/Default.vue';
import CommonSection from '@/components/CommonSection.vue';
import AdminSupplierFormPopupWrappable from '@/components/supplier/AdminSupplierFormPopupWrappable.vue';
import popup from '@/model/popup';
import { apiRun } from '@/model/apiRun';
import supplierApi from '@/api/supplier';
import { categoryTitle } from '@/utils/spec';

/**
 * Реестр поставщиков администратора (ТЗ 6.7): название, регион, категории, e-mail учётной записи,
 * число запросов; форма создания и правки. Операций удаления и блокировки нет (У36), поэтому в
 * реестре нет и кнопок удаления.
 *
 * Число запросов считает сервер и содержимое запросов не отдаёт (ТЗ 3.2). Сгенерировано Claude.
 */
export default {
  name: 'AdminSuppliersPage',
  components: { DefaultLayout, CommonSection },
  data() {
    return {
      suppliers: [],
      loading: true,
    };
  },
  created() {
    this.load();
  },
  methods: {
    async load(withPreloader = true) {
      const { items } = await supplierApi.fetchList({}, withPreloader);
      this.suppliers = (items ?? []).slice().sort((a, b) => (a.name ?? '').localeCompare(b.name ?? '', 'ru'));
      this.loading = false;
    },
    categoriesText(supplier) {
      return (supplier.categories ?? []).map(categoryTitle).join(', ') || '—';
    },
    create() {
      return this.openForm(null);
    },
    edit(supplier) {
      return this.openForm(supplier);
    },
    async openForm(supplier) {
      const result = await popup.add({
        wrappable: true,
        component: AdminSupplierFormPopupWrappable,
        params: { supplier },
      });
      if (!result) return;

      const saved = supplier
        ? await apiRun(
          () => supplierApi.update(supplier.id, result.params, true),
          'Не удалось сохранить карточку поставщика',
        )
        : await apiRun(
          () => supplierApi.create(result.params, true),
          'Не удалось создать поставщика',
        );
      if (!saved) return;
      await this.load(false);
    },
  },
};
</script>

<style scoped lang="scss">
.admin-suppliers-page {
  &__empty {
    font-size: 14px;
    color: var(--color-middle-gray);
  }

  &__table {
    width: 100%;
    border-collapse: collapse;
    font-size: 13px;

    th,
    td {
      text-align: left;
      padding: 8px 10px;
      border-bottom: 1px solid var(--color-super-light);
      vertical-align: middle;
    }

    th {
      color: var(--color-middle-gray);
      font-weight: 400;
      white-space: nowrap;
    }
  }

  &__name {
    font-weight: 700;
  }
}
</style>
